import React, { FC } from "react";
import icon from "../../../../assets/svg/drag.svg";

const DragIcon: FC = () => {
    return (
        <img draggable={false} src={icon} alt="close icon" style={{maxWidth: 15, objectFit: "contain"}}/>
    );
}

export default DragIcon;